import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { TableRow } from "@mui/material"
import { cloneElement } from "react"
import { Repeat } from "lib/@components/repeat"
import { range } from "library/range.mjs"
import { PreviewCell } from "routes/asset-register/plugins/excel-import/preview-cell"

export function PreviewRow({ item, index, last }) {
    const { firstColumn, lastColumn, columns } = useBoundContext()
    return (
        <TableRow data-cy={`excel-import-preview-row-${index}`}>
            {!!firstColumn && cloneElement(firstColumn, { row: item, index: index + 1, last })}
            <Repeat list={range(1, columns)} item={<PreviewCell row={item} />} />
            {!!lastColumn && cloneElement(lastColumn, { row: item, index, last })}
        </TableRow>
    )
}
